import { NgForm } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ConvenioAbonoService } from 'src/app/services/convenio-abono/convenio-abono.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogEditConvenioEjecutivo } from '../convenio/convenio-validar-ejecutivo.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { DialogPagoConvenio} from './convenio-pago.component';
import { DialogAnularConvenio } from '../convenio/convenio-anular.component';
import Swal from 'sweetalert2';



declare const Rut: any;
@Component({
  selector: 'app-convenio-abono-jub',
  templateUrl: '../../pages/convenio-abono/convenio-abono.html',
  styleUrls: ['../../pages/convenio-abono/convenio-abono.component.css']
})
export class ConvenioAbonoJubComponent implements OnInit
{
    convenios:any
    planes: any
    user: any
    rol: string = localStorage.getItem("rol")
    config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
    configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 10, indexInicial: 0, indexMaximo: 10 }
    tipoPostulacion : string = "Aprobadas"
    allComplete: boolean = false
    convenioSolicitado: any
    idEjecutivo = localStorage.getItem("idUsuario")
    nombreUsuario: any
    idUsuario:any
    rutUsuario:any
    categorias:any
    proveedores:any
    cuotas:any
    regiones:any
    totalMaximo:any
    selectConvenio: any={value:"0"}
    deshabilitado: true
    afiliado: any = {rutAfiliado:'',idAfiliado: '',nombreAfiliado:'', apellidoAfiliado:''};
    buscador: any =
    {  selectConvenio:0,
        rut:'', rut2:'',rutAfiliado:'', region:'', fechaInicio:'', fechaFin:'', itemsPerPage: 5, currentPage:1, idSolicitud:'',
        estado:['APROBADA']
    }
 
    constructor(public router: Router, public convenioAbonoService:ConvenioAbonoService,
                private dialog: MatDialog, 
                private tiposService: TiposService) { }

    ngOnInit(): void
    { this.loadData() }
   
    loadData()
    {
      let vm = this 
      this.idUsuario=localStorage.getItem("idUsuario");
      if(this.rol == 'ROLE_AFILIADO'){
        
        this.nombreUsuario = localStorage.getItem("nombreUsuario");
        this.rutUsuario = localStorage.getItem("rutUsuario")+"-"+localStorage.getItem("dvUsuario");
        if(this.rol == 'ROLE_AFILIADO'){
          this.afiliado.nombreAfiliado = this.nombreUsuario;
          this.afiliado.rutAfiliado = this.rutUsuario;
          this.afiliado.idAfiliado=this.idEjecutivo;
     
        }
        
        this.convenioAbonoService.traeConveniosPagados(this.idEjecutivo,this.buscador).then(
          (prestamosPagados : any) => {
            vm.convenios = prestamosPagados.resultado
            vm.buscador.paginasTotal = prestamosPagados.resultado.length
            vm.config.currentPage = this.buscador.currentPage
            vm.config.totalItems = prestamosPagados.cantidadRegistros
            Swal.close();
            
            
          }
    
          ).catch(error => console.log(error)) 
      
    } else{console.log("debe ingresar el rut!!!");}
  }
  anularConvenio(idPostulacion: any,idUsuario: any){
    let vm = this;
 
    let data: any ={idPostulacion: idPostulacion,
                    asientoContable:''}
            const dialogRef = this.dialog.open(DialogAnularConvenio,
             { width: '40%', data: data} )

            Swal.close();
            dialogRef.afterClosed().subscribe( () => {
               this.buscarListaConvenios(idUsuario);
               if (data.recarga) vm.loadData();
            } )
  }
  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }
  buscarListaConvenios(idUsuario: any){
    let vm = this 
    this.convenioAbonoService.traeConveniosPagados(idUsuario,this.buscador).then(
      (conveniosPagados : any) => {
        vm.convenios = conveniosPagados.resultado
        vm.buscador.paginasTotal = conveniosPagados.resultado.length
        vm.config.currentPage = this.buscador.currentPage
        vm.config.totalItems = conveniosPagados.cantidadRegistros
       
        Swal.close();
      }

      ).catch(error => console.log(error))
    }
    openEditDialogValidarConvenio(idConvenio:any,mostrarEditar?: any, disponiblePago?: any){
       
      this.convenioAbonoService.traeCategoriaConvenio().then(response =>  this.categorias = response).catch(error => console.log(error))
        this.convenioAbonoService.traeProveedorSelect().then(response => this.proveedores = response).catch(error => console.log(error))
        this.convenioAbonoService.traeCantidadCuotas().then(cuota =>this.cuotas = cuota).catch(error => console.log(error))
        this.convenioAbonoService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error))
        this.convenioAbonoService.traeMontoTotalDisponible(this.idEjecutivo).then(response => this.totalMaximo=response).catch(error =>{console.log(error); this.totalMaximo = 0;   });
        let vm = this
        let data: any = {}
        this.convenioAbonoService.traeConvenio(idConvenio).then(
            (response : any)=>{
                
                
                { 
                   
                    data.regiones = this.regiones,
                    data.categorias = this.categorias,
                    data.totalMaximo = this.totalMaximo,
                    data.proveedores = this.proveedores,
                    data.idCodeudor = this.idUsuario,
                    data.montoSolicitado = response.montoSolicitado,
                    data.idConvenio =  response.idConvenio,
                    data.idPostulacion = response.idPostulacion,
                    data.nombreUsuario = response.nombreUsuario,
                    data.rutUsuario = response.rutUsuario,
                    data.idCantidadCuota = response.idCantidadCuota,
                    data.montoCuota = response.montoCuota,
                    data.fechaIngreso = response.fechaIngreso,
                    data.fechaPrimerPago = response.fechaPrimerPago,
                    data.idTipoConvenio = response.idTipoConvenio,
                    data.idRegion = response.idRegion,
                    data.nombreCodeudorUno = response.nombreCodeudorUno,
                    data.nombreCodeudorDos = response.nombreCodeudorDos,
                    data.rutCodeudorUno = response.rutCodeudorUno,
                    data.rutCodeudorDos = response.rutCodeudorDos,
                    data.idProveedor = response.idProveedor,
                    data.idProducto = response.idProducto ,
                    data.idCarga = response.idCarga,
                    data.nombreCarga = response.nombreCarga,
                    data.rutCarga = response.rutCarga,
                    data.numPresupuesto = response.numPresupuesto,
                    data.mostrarEditar = mostrarEditar,
                    data.disponiblePago = disponiblePago,
                    data.idAfiliado = response.idUsuario,
                    this.convenioAbonoService.traeCantidadCuotasProveedor(response.idProveedor).
                    then(cuota =>data.cuotas = cuota).catch(error => console.log(error))
                    //cuotas: this.cuotas
                  }           
              
              
                  const dialogRef = vm.dialog.open(DialogEditConvenioEjecutivo,
                       { width: '40%', data: data} )
                       Swal.close();
                  dialogRef.afterClosed().subscribe( () => { } )
            }
        )
          .catch ( error =>
              {
                  console.log(error)
                  Swal.close();
                  this.openAlertDialog('No se pudo obtener la postulacion.', 'btn-danger')
              } )
              
  }
 
  verPlanPago(idConvenio: any){
  
	let vm = this
    this.convenioAbonoService.traePlanPagoConvenio(idConvenio).then(
      (resultado: any) => {
       vm.planes = resultado      
       Swal.close();    
      }
        ).catch(error => console.log(error))
  } 

  pagarDeuda(id: any, numCuota:any, editable:any,posicion: any, idplan:any, estadoPrevio: any, fechaPago: any, idTipoConvenio:any,idProveedor:any){

        if (posicion > 0 && editable && estadoPrevio == 'VIGENTE') {
          this.openAlertDialog('Se debe pagar antes la cuota '+posicion+ ' la cual está pendiente', 'btn-danger');
          Swal.close();
          return false;
        }       
        this.convenioAbonoService.ExisteOtroConvenio(id,this.afiliado.idAfiliado,idplan,fechaPago, idTipoConvenio,idProveedor).then(
          (response : any)=>{
          
           if(response){         
            this.openAlertDialog('Se debe pagar antes la cuota '+response.numCuota+' correspondiente a la solicitud '+response.idPostulacion, 'btn-danger');
            Swal.close();
            return false; 
           }else{
            this.traePlanAPagarConvenio(id,numCuota,idplan,editable)
           }
           
          }
          )
          .catch ( error =>
              {
                  console.log(error)
                  Swal.close();
                  this.openAlertDialog('No se pudo obtener la cuota a pagar.', 'btn-dark')
          } )

        
    }
    
    traePlanAPagarConvenio(id: any, numCuota:any,idplan:any,editable:any)
    {
      let vm = this
      this.convenioAbonoService.traePlanAPagarConvenio(id,numCuota,idplan).then(
        (response : any)=>{
            let data: any =
            {
                regionConvenio: response.regionConvenio,
                idConvenio: response.idConvenio,
                idPostulacion : response.idPostulacion,
                nombreUsuario : response.nombreUsuario,
                apellidoUsuario : response.setApPaternoUsuario,
                rutUsuario: response.rutUsuario,
                cantidadCuota : response.cantidadCuota,
                idCantidadCuota: response.idCantidadCuota,
                montoCuota: response.totalCuota,
                fechaIngreso:response.fechaIngreso,
                fechaPrimerPago :response.fechaPrimerPago,
                montoSolicitado:response.montoSolicitado,
                tipoConvenio: response.tipoConvenio, 
                tipoConvenioString: response.tipoConvenioString, 
                numCuota: numCuota,
                idPlanPago:response.idPlanPago,
                nombreProveedor: response.nombreProveedor,
                editable:editable
            }
            let vm =this;
           
            const dialogRef = vm.dialog.open(DialogPagoConvenio, 
                 { width: '35%',height: '95%', data: data} )
                 Swal.close();
            dialogRef.afterClosed().subscribe( () => { 
            this.verPlanPago( response.idConvenio);
          
          } )
        }
        )
        .catch ( error =>
            {
                console.log(error)
                Swal.close();
                this.openAlertDialog('No se pudo obtener la cuota a pagar.', 'btn-dark')
            } )


    }

   
    buscaAfiliado(rutABuscar: any)
       {

            if(Rut( rutABuscar))
            {
                let rut = rutABuscar.split('.').join('').split('-')[0]
    
                this.traePostulantes(rut);
                console.log("this.afiliado.idAfiliado ",this.afiliado.idAfiliado);
                

            }
            else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
             }
 

    
    traePostulantes(rut: any)
    {
       
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        let vm = this
        this.convenioAbonoService.traePostulantes(rut).then
        (
            (usuario: Usuario) =>
            {
    
                  vm.afiliado.nombreAfiliado =  usuario.nombres + ' ' + usuario.apellidoPaterno
                  vm.afiliado.rutAfiliado = usuario.rut+"-"+ usuario.dv
                  vm.afiliado.idAfiliado = usuario.id
                  vm.buscarListaConvenios(this.afiliado.idAfiliado);
                
                Swal.close();
                
            }
        )
        .catch ( error =>
        {
            console.log(error)
            Swal.close();
            vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
        } )
    }
    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir() { this.router.navigate(['/index']) }
        
    pageChanged(event: any,rutABuscar:any) {  
      this.config.currentPage = event 
      this.buscador.currentPage = event
      this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
      this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )
      let rut = rutABuscar.split('.').join('').split('-')[0]
      if(rut){
        this.traePostulantes(rut);  
      }      
    }


    

  
  }

  

